module.exports = __webpack_public_path__ + "img/operator4.96dae01d.png";